import { createSharedSlice } from '@luna/state';
import { logger } from '@luna/logger';
import type { AppearanceMode } from '@shared/dark-mode-utils';

const initialState: { isActive: boolean; appearanceMode: AppearanceMode } = {
    isActive: false,
    appearanceMode: 'LIGHT',
};

export const useDarkModeState = createSharedSlice({
    name: 'dark-mode',
    initialState,
    reducers: {
        saveAppearanceMode: (state, action: { payload: AppearanceMode }) => {
            state.appearanceMode = action.payload;

            switch (action.payload) {
                case 'SYSTEM':
                    state.isActive = window.matchMedia('(prefers-color-scheme: dark)').matches;
                    break;
                case 'DARK':
                    state.isActive = true;
                    break;
                case 'LIGHT':
                    state.isActive = false;
                    break;
                default:
                    logger.error(`Unknown DarkMode switch selection: ${action.payload}`);
            }
        },
    },
});

export const { saveAppearanceMode } = useDarkModeState.dispatchActions;

export const getDarkModeState = () => useDarkModeState.getState();
